import { applyMiddleware, legacy_createStore as createStore, compose } from 'redux';
import { thunk } from 'redux-thunk';
import localStorageMiddleware from './localStorageMiddleware';
import rootReducer from './rootReducer';
import { loadFromLocalStorage, saveToLocalStorage } from './localStorageUtils';

const composeEnhancers =
  (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
// create our store from our rootReducers and use loadFromLocalStorage
// to overwrite any values that we already have saved
const store = createStore(
  rootReducer,
  loadFromLocalStorage(),
  composeEnhancers(applyMiddleware(thunk, localStorageMiddleware)),
);

if (typeof window !== 'undefined') {
  window.__APP_STORE__ = store;
}

// listen for store changes and use saveToLocalStorage to
// save them to localStorage
store.subscribe(() => saveToLocalStorage(store.getState()));

export default store;
